import * as Sentry from '@sentry/react';

/**
 * Inicializa Sentry para la app `frontend`.
 *
 * Variables de entorno requeridas en `.env.local`:
 *   VITE_SENTRY_DSN=https://xxxx@oXXX.ingest.sentry.io/YYYY
 *   VITE_SENTRY_ENV=development | production
 */
export function initSentry() {
  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;

  if (!dsn) {
    console.warn('[Sentry] VITE_SENTRY_DSN no está definido — el reporte de errores está desactivado.');
    return;
  }

  Sentry.init({
    dsn,
    environment: (import.meta.env.VITE_SENTRY_ENV as string) ?? 'development',

    // ─── Identificador de la app dentro del proyecto Sentry ────────────────
    initialScope: {
      tags: { app: 'frontend' },
    },

    // ─── Performance tracing ───────────────────────────────────────────────
    tracesSampleRate: import.meta.env.DEV ? 1.0 : 0.1,

    // ─── Session Replay ────────────────────────────────────────────────────
    replaysSessionSampleRate: 0.0,
    replaysOnErrorSampleRate: 1.0,

    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({
        maskAllText: false,
        blockAllMedia: false,
      }),
    ],
  });
}
